import { createStore } from 'vuex'

export default createStore({
  state: {
    slug: localStorage.getItem('slug'),
    langes: [],
    deflange: localStorage.getItem('deflange'),
  },
  mutations: {
    SET_SLUG(state, slug) {
      state.slug = slug
      localStorage.setItem('slug', slug)
  },
  SET_LANGES(state, langes) {
    state.langes = langes
    //localStorage.setItem('langes', langes)
  },
  SET_DEFLANGE(state, deflange) {
    state.deflange = deflange
    localStorage.setItem('deflange', deflange)
  }
  },
  actions: {
  },
  modules: {
  },
  getters: {
    slug: state => state.slug,
    LANGES: state => state.langes,
    DEFLANGE: state => state.deflange,
    
}
})
